// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isCompanyInnovationInsidersOptInResult = objectOf({
  innovation_insiders_opt_in: boolean,
});
